<template>
  <Carousel
    v-if="images"
    :images="images"
    :showCarouselIndex="true" />
</template>

<script>
import Carousel from '@/components/Carousel'
import ImageBlock from '@/components/base/ImageBlock'

export default {
  name: 'Gallery',
  components: {
    Carousel
  },
  props: {
    images: {
      type: Array,
      default: null
    }
  },
  methods: {
    highlight(item) {
      if (item.highlight) {
        this.$root.$emit('highlight', {
          src: item.image.url,
          caption: item.caption,
          style: item.width > item.height ? 'landscape' : 'portrait'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.gallery {

}
</style>